import api from '../../utils/api'

import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'



/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormProduct from './Form/FormProduct'

function NewProduct({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()
    const navigate = useNavigate()

    

    async function registerProduct(obj) {
        let msgType = 'success'

        const data = await api.post('/product/new', obj, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }

    return (
        <FormProduct title="Novo Produto" handleSubmit={registerProduct} btCancelAction={btCancelAction} btnText="Cadastrar" />
    )
}

export default NewProduct